import LdGatedTab from 'lion-vue-src/Shared/components/LdFeatureGate/LdGatedTab';
export default LdGatedTab;
